import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthHeaderComponent } from '@app/layouts/auth/header/auth-header.component';
import { NgTemplateOutlet } from '@angular/common';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { AuthLayoutService } from '@app/layouts/auth/layout/auth-layout.service';

@Component({
  selector: 'math-auth-informer',
  imports: [AuthHeaderComponent, NgTemplateOutlet, NzFlexModule],
  templateUrl: './auth-informer.component.html',
  styleUrl: './auth-informer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthInformerComponent {
  public authLayoutService = inject(AuthLayoutService);
}
